export default __webpack_public_path__ + "static/weapons-e0436ca57ef817eac88d91a23dbe6925.png";